import React from "react"

export default function Blog039() {
  return (
    <section>
    <article>
    <h2>39. 02-02-2023</h2>
          <h3>Game Demo Release</h3>
          <p>
          <strong>Check out the game demo on my portfolio!</strong>
          <br /><br />
          As a game developer, I have had experience with various game engines including RPG Maker, Unreal Engine, and Unity. While I've created a few simple games in the past, they were never polished enough to be released. However, after acquiring programming skills in Javascript and Python, I have reignited my passion for game development.
          <br /><br />
Recently, I started using Ursina, a game engine based on Python, as a stepping stone to learn game development. Though Ursina proved to be a valuable learning experience, I encountered limitations when it came to creating entities with materials, textures, and lighting. This led me to explore other game engines that support game development with Python.
<br /><br />
I stumbled upon UPBGE, a game engine that allowed me to bring my game development skills to the next level. Being an experienced animator, I was already familiar with Blender and found UPBGE to be a great fit for my skillset. I have been using grease pencil and 3D assets, handcrafted by me from scratch, in my game development.
<br /><br />
In addition to the visual elements, I have also recorded the dialog and added game logic to the game. I am proud to share a demo of my game, which includes a main menu, a how-to-play menu, and several playable levels, on my portfolio.
<br /><br />
I am thrilled to be working on this project and cannot wait to share the finished product with the world. Currently, there is no estimated time for completion, but I invite you to play the demo and share your thoughts with me. Thank you for taking the time to read about my game development journey, and have a great day!
<br /><br />

<br /><br />
Thank you for your time,
<br /><br />
Eric Polley<br />
Software Developer Intern at In The Zone





         
          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
        <li>
            <a
              href="https://drive.google.com/u/0/uc?id=1FFS0MwxkEapj2C80Z-pFspNWO8kmS_wL&export=download&confirm=t&uuid=5817c4c6-384b-4edb-be90-def7727469e4&at=ALgDtsy7ssr7dhUjoLrYdamaFod4:1675368119870"
              title="Play my game Demo"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Play the New Game Demo</p></strong></
            a>
          </li>
        <br />
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
          <br />
        </ul>
        </ section >
  )
}
